import { getTutorialSelector, TUTORIAL_ANCHORS } from "../model/const/tutorialAnchors";

import type { DriveStep } from "driver.js";
import type { TFunction } from "i18next";

interface GetTutorialStepsParams {
    t: TFunction;
    onSkip: () => void;
    onAddFunds: () => void;
    onCreateCampaign: () => void;
}

const appendButton = (
    container: HTMLElement,
    text: string,
    onClick: () => void,
    position: "start" | "end" = "start",
) => {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "tutorial-popover__secondary-btn";
    button.textContent = text;
    button.addEventListener("click", onClick);

    if (position === "start") container.prepend(button);
    else container.append(button);
};

export const getTutorialSteps = ({
    t,
    onSkip,
    onAddFunds,
    onCreateCampaign,
}: GetTutorialStepsParams): DriveStep[] => {
    const anchorStep = (
        anchor: (typeof TUTORIAL_ANCHORS)[keyof typeof TUTORIAL_ANCHORS],
        key: string,
        side: "right" | "bottom" | "left",
        align: "start" | "center" | "end" = "start",
    ): DriveStep => ({
        element: getTutorialSelector(anchor),
        popover: {
            title: t(`tutorial.steps.${key}.title`),
            description: t(`tutorial.steps.${key}.description`),
            side,
            align,
        },
    });

    return [
        {
            popover: {
                title: t("tutorial.steps.welcome.title"),
                description: t("tutorial.steps.welcome.description"),
                showButtons: ["next"],
                showProgress: false,
                nextBtnText: t("tutorial.buttons.start"),
                popoverClass: "tutorial-popover tutorial-popover--center",
                onPopoverRender: (popover) => {
                    appendButton(popover.footerButtons, t("tutorial.buttons.skip"), onSkip);
                },
            },
        },
        anchorStep(TUTORIAL_ANCHORS.BALANCE, "balance", "bottom", "end"),
        anchorStep(TUTORIAL_ANCHORS.CREATE_CAMPAIGN, "create-campaign", "right"),
        anchorStep(TUTORIAL_ANCHORS.CAMPAIGNS, "campaigns", "right"),
        anchorStep(TUTORIAL_ANCHORS.REPORTS, "reports", "right"),
        anchorStep(TUTORIAL_ANCHORS.ASSETS, "assets", "right"),
        anchorStep(TUTORIAL_ANCHORS.CREATIVES, "creatives", "right"),
        anchorStep(TUTORIAL_ANCHORS.HELP, "help", "bottom", "end"),
        {
            popover: {
                title: t("tutorial.steps.final.title"),
                description: t("tutorial.steps.final.description"),
                showButtons: ["next", "previous"],
                showProgress: false,
                doneBtnText: t("tutorial.buttons.add-funds"),
                popoverClass: "tutorial-popover tutorial-popover--center",
                onPopoverRender: (popover) => {
                    appendButton(
                        popover.footerButtons,
                        t("tutorial.buttons.create-campaign"),
                        onCreateCampaign,
                        "end",
                    );
                    // "Add funds" should be the last (primary) action
                    popover.footerButtons.append(popover.nextButton);
                },
                onNextClick: onAddFunds,
            },
        },
    ];
};
